// src/locales/ta/report.js
export const report = {
  // Page Title
  salesReport: 'விற்பனை அறிக்கை',
  salesReportSubtitle: 'இணைய விளக்கப்படங்கள் மற்றும் விரிவான அட்டவணைகள் மூலம் விற்பனை தரவை பகுப்பாய்வு செய்யவும்',

  // Filter Section
  filters: 'வடிப்பான்கள்',
  applyFilters: 'வடிப்பான்களை பயன்படுத்தவும்',
  resetFilters: 'வடிப்பான்களை மீட்டமைக்கவும்',
  applying: 'பயன்படுத்துகிறது...',

  // Date Range
  dateRange: 'தேதி வரம்பு',
  dateFrom: 'தொடக்க தேதி',
  dateTo: 'முடிவு தேதி',
  selectDateRange: 'தேதி வரம்பைத் தேர்ந்தெடுக்கவும்',
  today: 'இன்று',
  thisWeek: 'இந்த வாரம்',
  thisMonth: 'இந்த மாதம்',
  lastMonth: 'கடந்த மாதம்',
  thisYear: 'இந்த ஆண்டு',
  customRange: 'விருப்ப வரம்பு',

  // Shared achieved/target labels (used by chart datasets)
  achieved: 'சாதனை',
  target: 'இலக்கு',

  // Grouping
  grouping: 'குழுவாக்கம்',
  groupByDate: 'தேதி அடிப்படையில் குழுவாக்கு',
  groupByWeek: 'வாரம் அடிப்படையில் குழுவாக்கு',
  groupByMonth: 'மாதம் அடிப்படையில் குழுவாக்கு',

  // Filter By Date Type
  filterByDateType: 'தேதி வகை அடிப்படையில் வடிகட்டு',
  createdDate: 'உருவாக்கிய தேதி',
  dispatchedDate: 'அனுப்பிய தேதி',

  // Shop Filter
  shop: 'கடை',
  allShops: 'அனைத்து கடைகளும்',
  selectShops: 'கடைகளைத் தேர்ந்தெடுக்கவும்',
  selectAll: 'அனைத்தையும் தேர்ந்தெடு',
  deselectAll: 'அனைத்தையும் நீக்கு',
  selectAtLeastOneShop: 'குறைந்தது ஒரு கடையைத் தேர்ந்தெடுக்கவும்',
  paymentType: 'கட்டண வகை',
  selectPaymentTypes: 'கட்டண வகைகளைத் தேர்ந்தெடுக்கவும்',
  salesRep: 'விற்பனை பிரதிநிதி',
  allSalesReps: 'அனைத்து விற்பனை பிரதிநிதிகள்',
  groupBySalesRep: 'விற்பனை பிரதிநிதி வாரியாகப் பிரித்துக் காட்டு',
  salesRepBreakdown: 'பிரதிநிதி வாரியான விற்பனை',
  unassignedSalesRep: 'ஒதுக்கப்படவில்லை',
  selectAtLeastOnePaymentType: 'குறைந்தது ஒரு கட்டண வகையைத் தேர்ந்தெடுக்கவும்',
  excludeDeliveryCharge: 'விற்பனை மதிப்பிலிருந்து டெலிவரி கட்டணத்தை விலக்கு',
  deliveryChargeSettingSaved: 'விற்பனை மதிப்பு அமைப்பு புதுப்பிக்கப்பட்டது',
  deliveryChargeSettingFailed: 'விற்பனை மதிப்பு அமைப்பைப் புதுப்பிக்க முடியவில்லை',
  selectAtLeastOneChannel: 'குறைந்தது ஒரு சேனலைத் தேர்ந்தெடுக்கவும்',
  channel: 'சேனல்',
  channelOnline: 'ஆன்லைன்',
  channelOffline: 'ஆஃப்லைன்',
  channelPos: 'POS',
  statusAppliesToOnline: 'நிலை வடிகட்டி ஆன்லைன் ஆர்டர்களுக்கு மட்டுமே பொருந்தும்',
  selectShop: 'கடையைத் தேர்ந்தெடுக்கவும்',

  // Status Filter
  orderStatus: 'ஆர்டர் நிலை',
  allStatuses: 'அனைத்து அனுப்பப்பட்ட நிலைகள்',
  selectStatuses: 'நிலைகளைத் தேர்ந்தெடுக்கவும்',

  // View Type
  viewType: 'காட்சி வகை',
  timePeriodView: 'கால அளவு காட்சி',
  productView: 'தயாரிப்பு காட்சி',

  // Summary Cards
  totalOrders: 'மொத்த ஆர்டர்கள்',
  totalRevenue: 'மொத்த வருவாய்',
  totalQuantity: 'மொத்த அளவு',
  orders: 'ஆர்டர்கள்',
  items: 'உருப்படிகள்',

  // Chart Section
  chartVisualization: 'வரைபடக் காட்சி',
  revenue: 'வருவாய்',
  quantity: 'அளவு',
  orderCount: 'ஆர்டர் எண்ணிக்கை',
  noDataAvailable: 'தேர்ந்தெடுத்த வடிப்பான்களுக்கு தரவு இல்லை',

  // Table Section
  dataTable: 'தரவு அட்டவணை',
  period: 'கால அளவு',
  productName: 'தயாரிப்பு பெயர்',
  productType: 'தயாரிப்பு வகை',
  quantitySold: 'விற்ற அளவு',
  totalValue: 'மொத்த மதிப்பு',
  actions: 'செயல்கள்',
  viewDetails: 'விவரங்களைப் பார்க்கவும்',

  // Product Types
  simple: 'எளியது',
  variable: 'மாறி',

  // Detailed View
  orderNumber: 'ஆர்டர் எண்',
  orderDate: 'ஆர்டர் தேதி',
  shopName: 'கடை',
  status: 'நிலை',
  quantity: 'அளவு',
  value: 'மதிப்பு',

  // Order Items
  variationDetails: 'மாறுபாட்டு விவரங்கள்',
  lineTotal: 'மொத்தம்',

  // Variations
  variationSku: 'SKU',
  attributeCombination: 'அம்ச இணைவு',

  // Pagination
  showing: 'காட்டுகிறது',
  to: 'வரை',
  of: 'இல்',
  results: 'முடிவுகள்',
  page: 'பக்கம்',
  previous: 'முந்தையது',
  next: 'அடுத்தது',

  // Export
  export: 'ஏற்றுமதி',
  exportToExcel: 'Excel க்கு ஏற்றுமதி',
  exportToCsv: 'CSV க்கு ஏற்றுமதி',
  exportChart: 'வரைபடத்தை ஏற்றுமதி',
  exporting: 'ஏற்றுமதி செய்கிறது...',
  exportSuccess: 'ஏற்றுமதி வெற்றிகரமாக முடிந்தது',
  exportFailed: 'ஏற்றுமதி தோல்வியடைந்தது',

  // Empty States
  noOrdersFound: 'ஆர்டர்கள் எதுவும் இல்லை',
  noOrdersMessage: 'தேர்ந்தெடுத்த வடிப்பான்களுக்கு பொருந்தும் ஆர்டர்கள் இல்லை. தயவுசெய்து வடிப்பான்களை மாற்றிப் பார்க்கவும்.',

  // Validation
  dateFromRequired: 'தொடக்க தேதி தேவை',
  dateToRequired: 'முடிவு தேதி தேவை',
  dateRangeInvalid: 'முடிவு தேதி தொடக்க தேதிக்குப் பிறகு இருக்க வேண்டும்',
  groupByDateRequired: 'குழுவாக்கம் தேவை',
  filterByDateRequired: 'தேதி அடிப்படையில் வடிகட்டு தேவை',

  // Loading
  loadingFilters: 'வடிப்பான்கள் ஏற்றப்படுகிறது...',
  loadingData: 'தரவு ஏற்றப்படுகிறது...',

  // Errors
  failedToLoadFilters: 'வடிப்பான்கள் ஏற்றுவதில் தோல்வி',
  failedToLoadData: 'விற்பனை தரவை ஏற்றுவதில் தோல்வி',
  tryAgain: 'மீண்டும் முயற்சிக்கவும்',

  // ── Profit & Loss Report ────────────────────────────────────────────────────
  pnlReport: {
    title: 'இலாப நட்ட அறிக்கை',
    subtitle: 'உங்கள் வணிகத்திற்கான விரிவான வருமான அறிக்கை',
    groupByLabel: 'காட்சி முறை',
    groupByNone: 'சுருக்கம்',
    groupByMonth: 'மாதாந்திரம்',
    groupByQuarter: 'காலாண்டு',
    thisQuarter: 'இந்த காலாண்டு',
    lastQuarter: 'கடந்த காலாண்டு',
    generateReport: 'அறிக்கை உருவாக்கு',
    generating: 'உருவாக்குகிறது...',
    exportExcel: 'Excel க்கு ஏற்றுமதி செய்',
    exporting: 'ஏற்றுமதி செய்கிறது...',
    revenue: 'வருவாய்',
    ecomSales: 'ஈகாம் விற்பனை',
    realizedSales: 'உணரப்பட்ட விற்பனை',
    unrealizedSales: 'உணரப்படாத விற்பனை',
    salesReturns: 'கழி: விற்பனை திரும்பல்',
    posSales: 'POS விற்பனை',
    lessPosReturns: 'கழி: POS திரும்பல்',
    netRevenue: 'நிகர வருவாய்',
    cogs: 'விற்கப்பட்ட பொருட்களின் செலவு',
    openingStock: 'தொடக்க இருப்பு',
    addPurchases: 'கூட்டு: கொள்முதல்',
    lessClosingStock: 'கழி: இறுதி இருப்பு',
    cogsTotal: 'விற்கப்பட்ட பொருட்களின் செலவு',
    posProductCost: 'POS தயாரிப்பு செலவு',
    grossProfit: 'மொத்த இலாபம்',
    operatingExpenses: 'செயல்பாட்டு செலவுகள்',
    courierCharges: 'கூரியர் கட்டணங்கள்',
    posFees: 'POS கட்டண கட்டணங்கள்',
    totalExpenses: 'மொத்த செயல்பாட்டு செலவுகள்',
    netProfit: 'நிகர இலாபம்',
    netLoss: 'நிகர நட்டம்',
    total: 'மொத்தம்',
    noData: 'தேர்ந்தெடுக்கப்பட்ட காலத்திற்கு தரவு இல்லை',
    selectFiltersPrompt: 'உங்கள் வடிப்பான்களை தேர்வு செய்து "அறிக்கை உருவாக்கு" என்பதை கிளிக் செய்யவும்',
    failedToLoad: 'இலாப நட்ட அறிக்கை தரவை ஏற்றுவதில் தோல்வி',
    failedToLoadFilters: 'வடிப்பான் விருப்பங்களை ஏற்றுவதில் தோல்வி',
  },

  courierPerformance: {
    title: 'பணியாளர் செயல்திறன் அறிக்கை',
    subtitle: 'பணியாளர் விநியோக செயல்திறனை விரிவான அளவுகோல்களுடன் பகுப்பாய்வு செய்யவும்',

    // Group By Options
    groupBy: 'குழுவாக',
    groupByRequired: 'குழுவாக்கம் தேவை',
    byDate: 'தேதி அடிப்படையில்',
    byWeek: 'வாரம் அடிப்படையில்',
    byMonth: 'மாதம் அடிப்படையில்',
    byShippingZone: 'அனுப்பும் பகுதி அடிப்படையில்',
    byDistrict: 'மாவட்ட அடிப்படையில்',
    byProvince: 'மாநில அடிப்படையில்',

    // Date Presets
    today: 'இன்று',
    thisWeek: 'இந்த வாரம்',
    thisMonth: 'இந்த மாதம்',
    lastMonth: 'கடந்த மாதம்',
    last30Days: 'கடந்த 30 நாட்கள்',
    last3Months: 'கடந்த 3 மாதங்கள்',
    customRange: 'விருப்ப வரம்பு',

    // Filters
    courierAccount: 'பணியாளர் கணக்கு',
    allCouriers: 'அனைத்து பணியாளர்கள்',

    // Summary Cards
    totalDelivered: 'மொத்த வழங்கல்',
    totalReturned: 'மொத்த திரும்பல்',
    inProcess: 'செயல்பாட்டில் உள்ளது',
    in_process: 'செயல்பாட்டில் உள்ளது',
    grandTotal: 'மொத்தம்',
    deliveryRate: 'வழங்கல் விகிதம்',
    returnRate: 'திரும்பல் விகிதம்',

    // Chart
    showByCount: 'எண்ணிக்கை அடிப்படையில் காட்டு',
    showByValue: 'மதிப்பு அடிப்படையில் காட்டு',
    delivered: 'வழங்கப்பட்டது',
    returned: 'திரும்பியது',

    // Table
    orderDetails: 'ஆர்டர் விவரங்கள்',
    all: 'அனைத்தும்',
    dispatchedDate: 'அனுப்பிய தேதி',
    customerName: 'வாடிக்கையாளர் பெயர்',
    location: 'இடம்',
    shippingZone: 'அனுப்பும் பகுதி',
    trackingNumber: 'பின்தொடர்பு எண்',
    amount: 'தொகை',
    codAmount: 'COD தொகை',
    deliveryStatus: 'வழங்கல் நிலை',
    searchOrders: 'ஆர்டர் எண், பின்தொடர்பு எண் அல்லது வாடிக்கையாளர் பெயர் மூலம் தேடவும்',
    orders: 'ஆர்டர்கள்',

    // Empty States
    noDataYet: 'தரவு இல்லை',
    selectFilters: 'பணியாளர் செயல்திறன் தரவை காண "வடிப்பான்களை பயன்படுத்தவும்" என்பதைத் தேர்ந்தெடுக்கவும்',
  },

  // NOTE: placeholder translation — needs native-speaker review before release
  messageCenterSummary: {
    title: 'செய்தி மைய சுருக்கம்',
    subtitle: 'செய்தி மைய ஷிப்ட் செயல்திறன் மற்றும் உறுதிப்படுத்தப்பட்ட ஆர்டர் அளவீடுகளைக் கண்காணிக்கவும்',
    kpiSectionTitle: 'முக்கிய அளவீடுகள்',
    kpiSectionTooltip: 'தேர்ந்தெடுக்கப்பட்ட தேதி வரம்பிற்கான சுருக்க அளவீடுகள்',
    createdOrders: 'உருவாக்கப்பட்ட ஆர்டர்கள்',
    createdOrdersTooltip: 'தேர்ந்தெடுக்கப்பட்ட காலகட்டத்தில் செய்தி மைய குழுவால் உருவாக்கப்பட்ட மொத்த ஆர்டர்கள்.',
    convertOrders: 'உறுதிப்படுத்தப்பட்ட ஆர்டர்கள்',
    convertOrdersTooltip: 'இன்னும் நிலுவையில், நிறுத்தி வைக்கப்பட்ட, அல்லது உறுதிப்படுத்தப்படாத ஆர்டர்களைத் தவிர்த்து, கூரியருக்கு அனுப்பப்பட்ட ஆர்டர்கள் — ஒரு செல்லுபடியான செயலாக்க கட்டம்.',
    deliveredOrders: 'வழங்கப்பட்ட ஆர்டர்கள்',
    deliveredOrdersTooltip: 'வழங்கப்பட்டதாக உறுதிப்படுத்தப்பட்ட ஆர்டர்கள் — முழுமையாக மூடப்பட்டு உள்நாட்டில் வழங்கப்பட்டவை, அல்லது கூரியரால் வழங்கப்பட்டதாக குறிக்கப்பட்டவை.',
    settledOrders: 'முடிக்கப்பட்ட ஆர்டர்கள்',
    settledOrdersTooltip: 'தீர்வு செயல்முறையை முடித்த வழங்கப்பட்ட ஆர்டர்கள்.',
    achievedVsTarget: 'சாதனை Vs இலக்கு',
    achievedVsTargetTooltip: 'ஷிப்டின் இலக்குக்கு எதிராக, கூரியருக்கு அனுப்பப்பட்ட ஆர்டர்களிலிருந்து அடையப்பட்ட விற்பனை மதிப்பு.',
    totalCommission: 'மொத்த கமிஷன்',
    totalCommissionTooltip: 'செய்தி மைய குழுவால் ஈட்டப்பட்ட மொத்த கமிஷன்.',
    leader: 'தலைவர்',
    createdProducts: 'உருவாக்கப்பட்ட தயாரிப்புகள்',
    createdValue: 'உருவாக்கப்பட்ட மதிப்பு',
    totalOrders: 'மொத்த ஆர்டர்கள்',
    totalProducts: 'மொத்த தயாரிப்புகள்',
    totalValue: 'மொத்த மதிப்பு',
    targetValue: 'இலக்கு மதிப்பு',
    commission: 'கமிஷன்',
    todayShiftTitle: 'இன்றைய சாதனை — {{shiftTypeName}}',
    todayShiftTooltip: 'உருவாக்கப்பட்ட ஆர்டர்கள், மொத்த தயாரிப்புகள், ஆர்டர் மதிப்பு, மற்றும் இலக்கு சாதனை சதவீதம் உள்ளிட்ட தேர்ந்தெடுக்கப்பட்ட தேதி வரம்பில் இந்த ஷிப்ட் வகையின் செயல்திறன் சுருக்கம்.',
    rangeShiftTitle: 'சாதனை — {{shiftTypeName}}',
    last7DaysTitle: 'கடந்த 7 நாட்கள் சாதனை Vs இலக்கு — {{shiftTypeName}}',
    last7DaysTooltip: 'கடந்த 7 நாட்களுக்கான நிர்ணயிக்கப்பட்ட இலக்குக்கு எதிராக அடையப்பட்ட விற்பனை மதிப்புகள்.',
    noShiftTypesFound: 'இந்த வணிகத்திற்கு இன்னும் ஷிப்ட் வகைகள் கட்டமைக்கப்படவில்லை',
    noDataYet: 'தரவு இல்லை',
    selectFiltersPrompt: 'செய்தி மைய சுருக்க தரவைக் காண உங்கள் வடிப்பான்களைத் தேர்ந்தெடுத்து "வடிப்பான்களை பயன்படுத்தவும்" என்பதைக் கிளிக் செய்யவும்',
    failedToLoad: 'செய்தி மைய சுருக்க தரவை ஏற்ற முடியவில்லை',
  },

  // NOTE: placeholder translation — needs native-speaker review before release
  callCenterSummary: {
    title: 'அழைப்பு மைய சுருக்கம்',
    subtitle: 'அழைப்பு மைய KPI கள், முகவர் செயல்திறன் மற்றும் குறுக்கு-விற்பனை முடிவுகளைக் கண்காணிக்கவும்',
    kpiSectionTitle: 'முக்கிய அளவீடுகள்',
    kpiSectionTooltip: 'தேர்ந்தெடுக்கப்பட்ட தேதி வரம்பிற்கான சுருக்க அளவீடுகள்',
    createdOrderItems: 'உருவாக்கப்பட்ட ஆர்டர் உருப்படிகள்',
    createdOrderItemsTooltip: 'உருவாக்கப்பட்ட ஆர்டர்களில் உள்ள மொத்த தயாரிப்புகளின் எண்ணிக்கை.',
    validOrderItems: 'செல்லுபடியான ஆர்டர் உருப்படிகள்',
    validOrderItemsTooltip: 'செல்லுபடியான/உறுதிப்படுத்தப்பட்ட ஆர்டர்களில் உள்ள மொத்த தயாரிப்புகளின் எண்ணிக்கை.',
    deliveredOrderItems: 'வழங்கப்பட்ட ஆர்டர் உருப்படிகள்',
    deliveredOrderItemsTooltip: 'வழங்கப்பட்டதாக உறுதிப்படுத்தப்பட்ட ஆர்டர்களில் உள்ள குறுக்கு-விற்பனை உருப்படிகள் — முழுமையாக மூடப்பட்டு உள்நாட்டில் வழங்கப்பட்டவை, அல்லது கூரியரால் வழங்கப்பட்டதாக குறிக்கப்பட்டவை.',
    settledOrderItems: 'முடிக்கப்பட்ட ஆர்டர் உருப்படிகள்',
    settledOrderItemsTooltip: 'முடிக்கப்பட்ட ஆர்டர்களில் உள்ள மொத்த தயாரிப்புகளின் எண்ணிக்கை.',
    inCourier: 'கூரியரில்',
    inCourierTooltip: 'கூரியர் கூட்டாளர்களுடன் போக்குவரத்தில் உள்ள தயாரிப்புகள்.',
    returns: 'திரும்பப்பெறல்',
    returnsTooltip: 'திரும்பப்பெறப்பட்ட அல்லது நிலுவையில் உள்ள திரும்பப்பெறல் ஆர்டர்களில் உள்ள தயாரிப்புகள்.',
    otherOrderItems: 'மற்ற ஆர்டர் உருப்படிகள்',
    otherOrderItemsTooltip: 'மற்ற ஆர்டர் நிலைகளில் உள்ள தயாரிப்புகள் (ரத்து செய்யப்பட்ட, நிறுத்தி வைக்கப்பட்ட, முதலியன).',
    discount: 'தள்ளுபடி',
    discountTooltip: 'ஆர்டர்களுக்கு பயன்படுத்தப்பட்ட மொத்த தள்ளுபடி தொகை.',
    products: 'தயாரிப்புகள்',
    orderValue: 'ஆர்டர் மதிப்பு',
    targetValue: 'இலக்கு மதிப்பு',
    commission: 'கமிஷன்',
    product: 'தயாரிப்பு',
    count: 'எண்ணிக்கை',
    revenue: 'வருவாய் (LKR)',
    name: 'பெயர்',
    remaining: 'மீதமுள்ளது',
    targetAchieved: 'இலக்கு அடையப்பட்டது',
    rank: 'தரம்',
    confirmCount: 'உறுதிப்படுத்தல் எண்ணிக்கை',
    sales: 'விற்பனை',
    todayAchievement: 'சாதனை (தேர்ந்தெடுக்கப்பட்ட காலம்)',
    todayAchievementTooltip: 'தேர்ந்தெடுக்கப்பட்ட காலத்தில் உறுதிப்படுத்தப்பட்ட ஆர்டர்களுக்கான குறுக்கு-விற்பனை செயல்திறன் — தயாரிப்புகள், ஆர்டர் மதிப்பு, இலக்கு, தள்ளுபடி, மற்றும் கமிஷன்.',
    periodLabel: 'காலம்',
    last7DaysTitle: 'கடந்த 7 நாட்கள் சாதனை Vs இலக்கு',
    last7DaysTooltip: 'கடந்த 7 நாட்களுக்கான அழைப்பு மைய அடையப்பட்ட விற்பனை மதிப்பு Vs இலக்கு செயல்திறன்.',
    crossSellingTitle: 'அதிக குறுக்கு-விற்பனை தயாரிப்புகள்',
    crossSellingTooltip: 'தேர்ந்தெடுக்கப்பட்ட காலகட்டத்திற்கான ஆர்டர் எண்ணிக்கையின் அடிப்படையில் சிறந்த 10 தயாரிப்புகள்.',
    targetPerAgentTitle: 'முகவர் ஒன்றுக்கான இலக்கு',
    targetPerAgentTooltip: 'தேர்ந்தெடுக்கப்பட்ட காலகட்டத்திற்கான ஒவ்வொரு முகவரின் குறுக்கு-விற்பனை இலக்கு Vs அடையப்பட்ட மதிப்பு.',
    agentPerformanceTitle: 'முகவர் செயல்திறன்',
    agentPerformanceTooltip: 'தேர்ந்தெடுக்கப்பட்ட காலகட்டத்திற்கான மொத்த உறுதிப்படுத்தப்பட்ட-ஆர்டர் விற்பனை மதிப்பின் அடிப்படையில் அனைத்து முகவர்களின் தரவரிசை (குறுக்கு-விற்பனை மட்டுமல்ல, எந்த ஆர்டரும்).',
    noDataYet: 'தரவு இல்லை',
    selectFiltersPrompt: 'அழைப்பு மைய சுருக்க தரவைக் காண உங்கள் வடிப்பான்களைத் தேர்ந்தெடுத்து "வடிப்பான்களை பயன்படுத்தவும்" என்பதைக் கிளிக் செய்யவும்',
    failedToLoad: 'அழைப்பு மைய சுருக்க தரவை ஏற்ற முடியவில்லை',
  },
  // TODO(si/ta): English placeholders — translate
  productWiseSales: {
    title: 'Product Wise Sales',
    description: 'Units, amounts and discounts per product for dispatched orders',
    shops: 'Shops',
    allShops: 'All shops',
    dateRange: 'Dispatched Date',
    searchPlaceholder: 'Search products...',
    excel: 'Excel',
    pdf: 'PDF',
    noData: 'No product sales found for the selected filters',
    failedToLoad: 'Failed to load product wise sales',
    exportFailed: 'Failed to export report',
    cards: {
      orderCount: 'Total Order Count',
      orderAmount: 'Total Order Amount',
      orderDiscount: 'Total Order Discount',
      productCount: 'Total Product Count',
      productAmount: 'Total Product Amount',
      productDiscount: 'Total Product Discount',
    },
    columns: {
      productName: 'Title',
      itemCount: 'Item Count',
      amount: 'Amount',
      contribution: 'Contribution (%)',
      discount: 'Discount',
      amountAfterDiscount: 'Amount After Discount',
      amountPerItem: 'Amount per Item',
      discountPerItem: 'Discount per Item',
      discountPctPerItem: 'Discount % per Item',
    },
  },
  // TODO(si/ta): English placeholders — translate
  productWiseReturns: {
    title: 'Product Wise Returns',
    description: 'Units, amounts and discounts per product for returned orders',
    shops: 'Shops',
    allShops: 'All shops',
    dateRange: 'Return Date',
    allReturnSources: 'All return batches & notes',
    searchReturnSources: 'Search return batches & notes...',
    returnBatch: 'Return Batch',
    returnNote: 'Return Note',
    searchPlaceholder: 'Search products...',
    excel: 'Excel',
    pdf: 'PDF',
    noData: 'No product returns found for the selected filters',
    failedToLoad: 'Failed to load product wise returns',
    exportFailed: 'Failed to export report',
    cards: {
      orderCount: 'Total Return Order Count',
      orderAmount: 'Total Return Order Amount',
      orderDiscount: 'Total Return Order Discount',
      productCount: 'Total Returned Product Count',
      productAmount: 'Total Returned Product Amount',
      productDiscount: 'Total Returned Product Discount',
    },
    columns: {
      productName: 'Title',
      itemCount: 'Item Count',
      amount: 'Amount',
      contribution: 'Contribution (%)',
      discount: 'Discount',
      amountAfterDiscount: 'Amount After Discount',
      amountPerItem: 'Amount per Item',
      discountPerItem: 'Discount per Item',
      discountPctPerItem: 'Discount % per Item',
    },
  },
  ccPerformanceUsers: {
    selectUsers: "பயனர்களைத் தேர்ந்தெடு",
    title: "அறிக்கையில் காட்டப்படும் பயனர்கள்",
    hint: "சேர்க்க வேண்டிய பயனர்களைத் தேர்ந்தெடுக்கவும். எதுவும் தேர்ந்தெடுக்கப்படவில்லை எனில், அனைத்து பயனர்களும் காட்டப்படுவர்.",
    selectAll: "அனைத்தையும் தேர்ந்தெடு",
    clearAll: "அனைத்தையும் அழி",
    saved: "பயனர் தேர்வு சேமிக்கப்பட்டது",
    saveFailed: "பயனர் தேர்வைச் சேமிக்க முடியவில்லை",
    loadFailed: "பயனர்களை ஏற்ற முடியவில்லை",
    searchUsers: "பெயரால் பயனர்களைத் தேடு",
    noUsersFound: "பயனர்கள் எவரும் கிடைக்கவில்லை",
  },
};
